import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { ButtonResponsive, FlexRow } from '@framework/ui';
import { Space } from 'antd';
import React, { useMemo } from 'react';
import { CardFooterButtons } from '../navigation/CardFooterButtons';
import { SubmissionCancelButton } from '../navigation/buttons/SubmissionCancelButton';
import { ISubmissionNavigator } from '../navigation/useSubmissionNavigation';
import { SubmissionMenuKey } from '../submission/hooks/useSubmissionMenuItems';

export interface ISubmissionBurdenCardFooterProps {
  handleNavigation: ISubmissionNavigator;
  readonly?: boolean;
}

export function SubmissionBurdenCardFooter(
  props: ISubmissionBurdenCardFooterProps,
) {
  const { handleNavigation, readonly } = props;

  const { t } = useTranslation();

  const canNext = useMemo(() => {
    return handleNavigation.canNext(SubmissionMenuKey.Payment);
  }, [handleNavigation]);

  return (
    <CardFooterButtons>
      <FlexRow
        right={
          <Space>
            {readonly && <SubmissionCancelButton />}
            {canNext && (
              <ButtonResponsive
                size="large"
                type="primary"
                text={t('form.avanti', 'Avanti')}
                iconRightComponent={ArrowRightOutlined}
                iconRightAriaLabel={t('form.avanti', 'Avanti')}
                onClick={() => {
                  handleNavigation.navigate(SubmissionMenuKey.Payment, 'next');
                }}
              />
            )}
          </Space>
        }
      >
        <ButtonResponsive
          size="large"
          type="default"
          text={t('form.indietro', 'Indietro')}
          iconLeftComponent={ArrowLeftOutlined}
          iconLeftAriaLabel={t('form.indietro', 'Indietro')}
          onClick={() => {
            handleNavigation.navigate(SubmissionMenuKey.Payment, 'previous');
          }}
        />
      </FlexRow>
    </CardFooterButtons>
  );
}
